import React, { useEffect, useState, useCallback } from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import './App.css';
import Header from './components/Header/Header';
import Form from './components/Body/Form/Form';
import Result from './components/Body/Result/Result';
import NoResults from './components/Body/NoResults/NoResults';
import Error from './components/Body/Error/Error';
import { getAppOptions } from './utils/lib';
import jsPDF from 'jspdf';
import LoadingSpinner from './components/UI/LoadingSpinner/LoadingSpinner';
import LoadingOverlay from './components/UI/LoadingOverlay/LoadingOverlay';


const render = (status) => {
  if(status === Status.FAILURE) return <Error errorMessage={'Unable to load Google Maps Javascript API'}/>;
  return <LoadingSpinner/>;
}
function App() {
  //generating pdf state (show loading pdf state or not)
  const [loading, setLoading] = useState(false);

  //Zero results
  const [zeroResults, setZeroResults] = useState({zeroResultsId: null, zeroResultsMessage: '', zeroResultsState:false});

  const [calculate, setCalculate] = useState(false);
  //const [finishedCalculation, setFinishedCalculation] = useState(false);
  const [portDistances, setPortDistances] = useState([]);
  const [toDestination, setToDestination] = useState([]);
  const [fromDestination, setFromDestination] = useState([]);
  const [totalDistance, setTotalDistance] = useState([]);
  const [calculatedCo2, setCalculatedCo2] = useState({});
  const [generatingPDF, setGeneratingPDF] = useState(false);

  const generatePDFHandler = () => {
    setGeneratingPDF(true);
    const pdf = new jsPDF({unit: "px", format:"letter", userUnit:"px", orientation:"portrait"});
    
    document.getElementById('tsg-app').classList.add('pdf-temp-css');
    document.getElementById('tsg-results-result-row-id').classList.add('pdf-temp-row-css');
    document.getElementById('tsg-results-result-row-id-2').classList.add('pdf-temp-width');
    document.getElementById('tsg-results-result-row-id-3').classList.add('pdf-temp-width');
    const input = document.querySelector('#tsg-app');

    pdf.html(input, {html2canvas: { scale:0.47 }}).then(() =>{ 
        pdf.save('tsgco2.pdf');
        document.getElementById('tsg-app').classList.remove('pdf-temp-css');
        document.getElementById('tsg-results-result-row-id').classList.remove('pdf-temp-row-css');
        document.getElementById('tsg-results-result-row-id-2').classList.remove('pdf-temp-width');
        document.getElementById('tsg-results-result-row-id-3').classList.remove('pdf-temp-width');
    });
    setTimeout(() => {
      setGeneratingPDF(false);  
    }, 1000);
  }

  const submitDataHandler = (data, toDest, fromDest) => {
      setLoading(true);
      setPortDistances(data);
      setToDestination(toDest);
      setFromDestination(fromDest);
  }

  const totalDistanceHandler = (data) => {
      setTotalDistance(data);
  }

  const onCalculateHandler = (data) => {
     
      setCalculate(data);
  }

  const calculateCo2 = useCallback(async () => {
      
      const options = await getAppOptions();

      //console.log(options);
      //Need to check reversed keys
      let combinedKey = portDistances[0].portKey +'_'+ portDistances[1].portKey;
      let combinedKeyReversed = portDistances[1].portKey +'_'+ portDistances[0].portKey;
      console.log(combinedKey, combinedKeyReversed);
      let combinedKeyDistance = 0;
      for(let i = 0; i < options.combination_ports.length; i++){
        if(combinedKey === options.combination_ports[i].combined_port_country_key || combinedKeyReversed === options.combination_ports[i].combined_port_country_key){
          combinedKeyDistance = options.combination_ports[i].distance_ports;
        }
      }
      console.log(combinedKeyDistance);
      if(combinedKeyDistance === 0){
        //this route isnt manned with ships
        //finds a key, but there is no keycombinations
        //Example today is UK - NL key
        setZeroResults({ 
          zeroResultsId: 1, 
          zeroResultsMessage:'The current origin doesnt ship to the given destiantion', 
          zeroResultsState: true
        });
      }

      console.log(totalDistance);
      //calculate co2 for seafreight (emission_constant * base_weight * combinedKeyDistance)
      //combinedKeydistance is in KM
      //Baseweight is in tons
      //emission_constant is in ton/km 
      let base_weight = 14;
      let co2Seafreight = (Number(options.emission_ship) * base_weight * combinedKeyDistance)/1000;
      
      //calculate co2 for road shipping
      let fromConstant = 0;
      let toConstant = 0;

      for(let i = 0; i < options.emissions_country.length; i++){
        //check country code for port
        //starting port of journey
        if( portDistances[0].portKey.includes(options.emissions_country[i].country_key) ){
          fromConstant = options.emissions_country[i].emissions_constant;
        } 
        //ending port of journey
        if( portDistances[1].portKey.includes(options.emissions_country[i].country_key) ){
          toConstant = options.emissions_country[i].emissions_constant;
        }
      }
      //The distance is in meters. Divide by 1000 to get km
      let co2FromShipping = fromConstant * (portDistances[0].shortestDistance/1000);
      let co2ToShipping = toConstant * (portDistances[1].shortestDistance/1000);

      //calculate if only road shipping use the current ports for co2 constant
      let co2ByRoad =  (totalDistance[2]/1000)*fromConstant;
      
      setCalculatedCo2({
        "seaDistance": combinedKeyDistance, 
        "co2Sea": co2Seafreight,
        "co2FromShipping": co2FromShipping,
        "co2ToShipping": co2ToShipping,
        "co2ByRoad": co2ByRoad,
        "calcDone": true
      });
      
      
  },[portDistances, totalDistance]);

  const handleZeroResults = (value) => {
    setZeroResults(value);
  }

  useEffect(() => {
    if(calculate === true){
      calculateCo2();
    } 
    
    return() => {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    };
  }, [calculate, calculateCo2]);
  
  return (
    <div id="tsg-app-outer">
      <div id="tsg-app">
          <Header />
          <Wrapper apiKey={"AIzaSyBS8uPATYdJKZznOH8CMkrn7ruzB4L77jw"} libraries={["places, distanceMatrix"]} render={render}>
              
              {loading && <LoadingSpinner />}
              
              {!calculate && !loading && <Form setTotalDistance={totalDistanceHandler} setDataHandler={submitDataHandler} setOnCalculate={onCalculateHandler} zeroResults={handleZeroResults}/>}
            
              {(!loading && calculate && !zeroResults.zeroResultsState && calculatedCo2.calcDone) && <Result toDestination={toDestination} fromDestination={fromDestination} portDistances={portDistances} calculatedCo2Vals={calculatedCo2} totalDistance={totalDistance} generatePDF={generatePDFHandler}/> } 
              {/* {(!generating && finishedCalculation && !zeroResults) && <Result toDestination={TEMP_TO} fromDestination={TEMP_FROM} portDistances={PORT_DISTANCES} calculatedCo2={TEMP_CO2} totalDistance={TEMP_TOT_DISTANCE} generatePDF={generatePDFHandler} />} */}
              
              {(!loading && zeroResults.zeroResultsState) && <NoResults results={zeroResults} toDestination={toDestination} fromDestination={fromDestination} />}
              
            
            
          </Wrapper>
      </div>
      {generatingPDF && <LoadingOverlay />}
    </div>
  );
}

export default App;